import store from "../../vue/store";
import {SecurityContainer} from "../SecurityContainer";
import {HashRouter} from "../HashRouter";

export class ProductListItem {
    constructor(element) {
        this.element = element;
        this.productId = parseInt(element.getAttribute('data-product-id'));

        this.state = {
            wishListProcessing: false
        };

        this.enableHover();
        this.renderWishListIcon();
    }

    enableHover() {
        this.isHover = false;

        const showImage = () => {
            const renderImage = !this.isHover && !this.element.classList.contains('show-product-item-alcohol-alert');

            if (false === renderImage) {
                return;
            }

            const wrapper = this.element.querySelector('.products-list-item-image');
            const image = wrapper.querySelector('img');

            if (image) {
                const imagePreviewUrl = image.getAttribute('data-image-preview');

                if (!imagePreviewUrl) {
                    return;
                }

                let previewElement = wrapper.querySelector('.product-list-item-preview');

                if (!previewElement) {
                    previewElement  = document.createElement("div");
                    previewElement.classList.add('product-list-item-preview');
                    previewElement.style.backgroundImage = `url(${imagePreviewUrl})`;

                    wrapper.appendChild(previewElement);

                    setTimeout(() => {
                        let previewElement = wrapper.querySelector('.product-list-item-preview');

                        previewElement.classList.add('show-preview');
                    }, 50)
                } else {
                    previewElement.classList.remove('hide-preview');
                    previewElement.classList.add('show-preview');
                }
            }

            this.isHover = true;
        };

        const hideImage = () => {
            const element = this.element.querySelector('.product-list-item-preview');

            if (element) {
                element.classList.remove('show-preview');
                element.classList.add('hide-preview');
            }

            this.isHover = false;
        };

        this.element.addEventListener("mouseover", showImage);
        this.element.addEventListener("mouseleave", hideImage);

        return this;
    }

    renderWishListIcon() {
        const currentProductId = this.productId;

        /**
         * @param productId
         * @return {boolean}
         */
        const productInWishList = productId => {
            const wishListProducts = store.getters['wishList/products'];
            const productModel = wishListProducts.find(model => model.id === productId);

            return !!productModel;
        };

        /**
         * @param {object} event
         */
        const toggleProductInWishList = async event => {
            event.preventDefault();
            event.stopPropagation();

            if (this.state.wishListProcessing) {
                return;
            }

            this.state.wishListProcessing = true;

            const productIsChecked = productInWishList(currentProductId);
            const icon = this.element.querySelector('.products-list-item-clipboard .icon');

            icon.classList.remove('icon-heart');
            icon.classList.remove('icon-heart-filled');
            icon.classList.add('icon-loading');
            icon.classList.add('icon-rotate');

            const storeAction = productIsChecked
                ? 'wishList/removeProductById'
                : 'wishList/addProductById'
            ;

            try {
                await store.dispatch(storeAction, currentProductId);
            } catch (error) {
                toast.error("Wystąpił błąd")
            }

            icon.classList.remove('icon-loading');
            icon.classList.remove('icon-rotate');

            if (productIsChecked) {
                icon.classList.add('icon-heart');
            } else {
                icon.classList.add('icon-heart-filled');
            }

            this.state.wishListProcessing = false;

            return false;
        };

        /**
         * @param {object} event
         */
        const showLoginPopup = event => {
            event.preventDefault();

            HashRouter.redirect('login-modal', {type: "wishlist"});
        };

        /**
         * @param {boolean} checked
         * @return {HTMLElement}
         */
        const renderIcon = checked => {
            const iconWrapper = document.createElement("span");
            const icon = document.createElement("i");

            iconWrapper.classList.add('products-list-item-clipboard');
            icon.classList.add('icon');
            icon.classList.add(checked ? 'icon-heart-filled' : 'icon-heart');

            iconWrapper.appendChild(icon);

            return iconWrapper
        };

        if (SecurityContainer.userIsLogged()) {
            store.subscribe(mutation => {
                const mutationType = mutation.type;
                const mutationPayload = mutation.payload;

                switch (mutationType) {
                    // Render icon when wish list will be fetch
                    case 'wishList/setLoading':
                        if (false === mutationPayload) {
                            const checked = productInWishList(currentProductId);
                            const icon = renderIcon(checked);

                            icon.addEventListener('click', toggleProductInWishList);

                            this.element.appendChild(icon);
                        }
                        break;
                    case 'wishList/removeProductById':
                        if (currentProductId === mutationPayload) {
                            const icon = this.element.querySelector('.products-list-item-clipboard .icon');
                            icon.classList.remove('icon-heart-filled');
                            icon.classList.add('icon-heart');
                        }
                        break;
                }
            })
        } else {
            const checked = false;
            const icon = renderIcon(checked);

            icon.addEventListener('click', showLoginPopup);

            this.element.appendChild(icon);
        }

        return this;
    }
}
